import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Inairdata from '../entities/inairdata'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface InairdataState extends ListState<Inairdata>{
    analyseInairdata: Inairdata
}
class UserMutations extends ListMutations<Inairdata>{

}
class InairdataModule extends ListModule<InairdataState,any,Inairdata>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        analyseInairdata:new Inairdata(),
        list: new Array<Inairdata>(),
        loading:false,
        editInairdata:new Inairdata()
    }
    actions={
        async getAllPaged(context:ActionContext<InairdataState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Inairdata/GetAllPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Inairdata>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getPagedLast(context: ActionContext<InairdataState, any>, payload: any) {
            // context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Inairdata/GetPagedLast', { params: payload.data });
            // context.state.loading = false;
            let page = reponse.data.result as PageResult<Inairdata>;
            //context.state.totalCount = page.totalCount;
            //context.state.list = page.items;
            return page.items;
        },
        async getPaged(context:ActionContext<InairdataState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Inairdata/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Inairdata>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<InairdataState,any>,payload:any){
            await Ajax.post('/api/services/app/Inairdata/Create',payload.data);
        },
        async update(context:ActionContext<InairdataState,any>,payload:any){
            await Ajax.put('/api/services/app/Inairdata/Update',payload.data);
        },
        async delete(context:ActionContext<InairdataState,any>,payload:any){
            await Ajax.delete('/api/services/app/Inairdata/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<InairdataState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Inairdata/GetById?Id='+payload.id);
            return reponse.data.result as Inairdata;
        },
        async getPageByDate(context: ActionContext<InairdataState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Inairdata/GetPageByDate', { params: payload.data });
            let page = reponse.data.result as PageResult<Inairdata>;
            return page.items;
        }
        // async getWarning(context:ActionContext<InairdataState,any>,payload:any){
        //     let reponse=await Ajax.get('/api/services/app/Inairdata/GetWarningList');
        //     return reponse.data.result.items;
        // },
        // async getRank(context:ActionContext<InairdataState,any>,payload:any){
        //     let reponse=await Ajax.get('/api/services/app/Inairdata/GetRankList?day='+payload.data);
        //     return reponse.data.result.items;
        // }

    };
    mutations={
        setCurrentPage(state:InairdataState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:InairdataState,pagesize:number){
            state.pageSize=pagesize;
        },
        analyse(state: InairdataState, inairdata: Inairdata) {
            state.analyseInairdata = inairdata;
        },
    }
}
const inairdataModule=new InairdataModule();
export default inairdataModule;